import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const root = css`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const listItem = (theme: Theme) => css`
  margin-bottom: ${theme.spacing[8]};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const listItemText = (theme: Theme) => css`
  margin: ${theme.spacing[0]} ${theme.spacing[8]};
  color: ${theme.palette.text.description};
`;

export const checkedListItemText = (theme: Theme) => css`
  color: ${theme.palette.secondary.maxContrast};
  font-weight: 500;
`;

export const listItemIcon = (theme: Theme) => css`
  display: flex;
  color: ${theme.palette.text.description};
  width: ${theme.spacing[20]};
  height: ${theme.spacing[20]};
`;
